// The single save path for every custom field editor on the list: Util.CommitMutation (correlation-id
// error modal, transient-network retry), then the page's retry() on SUCCESS only. On failure
// Util.CommitMutation's standard modal shows and the cell keeps its previous value, because nothing was
// patched.
import Util from '../../../../shared/util/util';
import UpdateCustomFieldListValueMutation from '../../../../../mutations/update_custom_field_list_value_mutation';
import type {CustomFieldColumnDef} from '../../../../shared/components/custom-field-columns/customFieldColumnModel';
import type {OpportunityNode} from '../../../opportunityTypes';

export interface SaveCustomFieldValueArgs {
	node: OpportunityNode;
	def: CustomFieldColumnDef;
	value: string | null;
	onCommit: () => void;
}

export const saveCustomFieldValue = ({node, def, value, onCommit}: SaveCustomFieldValueArgs): void => {
	Util.CommitMutation(
		UpdateCustomFieldListValueMutation,
		{entityId: node.id, entityType: 'PROJECT', key: def.key, value},
		() => onCommit()
	);
};
